import React from 'react';
import GraficoBarrasVertical from 'components/GraficoBarrasVertical';
import { montarGraficoPerformanceGeralResumido } from './relatorioResumido';

export default function PerformanceGeralResumido({ filtroSelecionado, dadosGrafico }) {
  return (
    <>
      {montarGraficoPerformanceGeralResumido(dadosGrafico, filtroSelecionado)?.map(dadosAno => {
        return <GraficoBarrasVertical key={dadosAno.id || dadosAno.title} dados={dadosAno} title={dadosAno.title} />;
      })}
    </>
  );
}
